/** Returns the user's age in completed years, accounting for month and day. */
export function calculateExactAge(birthdate: Date, referenceDate?: Date): number {
  const today = referenceDate ?? new Date()
  let age = today.getFullYear() - birthdate.getFullYear()

  const hasBirthdayPassedThisYear =
    today.getMonth() > birthdate.getMonth() ||
    (today.getMonth() === birthdate.getMonth() &&
      today.getDate() >= birthdate.getDate())

  if (!hasBirthdayPassedThisYear) {
    age--
  }
  return age
}
